module.exports = __webpack_public_path__ + "img/fact_bg2.31808059.png";